import classNames from 'classnames'
import { Stat } from './Stat'
import { Divider, Link, Text } from '@lounge-fe/ui-kit'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { StatData, StatsProps } from './types'

export const Stats: ShopifySectionComponent<StatsProps> = ({
  data = { stats: [] },
}) => {
  const stats = data.stats

  return (
    <div
      className={classNames(
        'flex flex-col items-center gap-y-6 md:gap-y-10 wrapper wrapper--size-sm',
      )}
    >
      {data.heading && (
        <Text
          variant="display-two"
          className="typography typography--title-three italic"
        >
          {data.heading}
        </Text>
      )}

      <div className="flex flex-col gap-15 md:gap-0 md:grid md:grid-cols-3 justify-evenly w-full">
        {stats.flatMap((stat: StatData, idx: number) => {
          const elements = [
            <Stat
              key={`stat-${idx}`}
              {...stat}
              className="flex flex-col items-center gap-y-2 min-w-[250px] text-center"
            />,
          ]

          if (idx === 2 && stats.length > 3) {
            elements.push(
              <Divider className="w-full my-0 md:my-10 sm:col-span-3" />,
            )
          }

          return elements
        })}
      </div>

      {data.link && (
        <Link
          className="typography typography--body-md underline mt-4 md:mt-0"
          href={data.link}
        >
          {data.linkText}
        </Link>
      )}
    </div>
  )
}
